import { render, staticRenderFns } from "./LocationBulkCreate.vue?vue&type=template&id=52dfc7a7"
import script from "./LocationBulkCreate.vue?vue&type=script&lang=js"
export * from "./LocationBulkCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports